__turbopack_context__.v({
  "ariaSlider": "PlasmicSlider-module__zV6nIa__ariaSlider",
  "ariaSliderOutput": "PlasmicSlider-module__zV6nIa__ariaSliderOutput",
  "ariaSliderTrack": "PlasmicSlider-module__zV6nIa__ariaSliderTrack",
  "background": "PlasmicSlider-module__zV6nIa__background",
  "description": "PlasmicSlider-module__zV6nIa__description",
  "foreground": "PlasmicSlider-module__zV6nIa__foreground",
  "freeBox__kh41": "PlasmicSlider-module__zV6nIa__freeBox__kh41",
  "freeBox__uaE0L": "PlasmicSlider-module__zV6nIa__freeBox__uaE0L",
  "sliderThumb__ct82M": "PlasmicSlider-module__zV6nIa__sliderThumb__ct82M",
  "slotTargetLabel": "PlasmicSlider-module__zV6nIa__slotTargetLabel",
  "text": "PlasmicSlider-module__zV6nIa__text",
  "text___3WelL": "PlasmicSlider-module__zV6nIa__text___3WelL",
});
